import React from 'react';

export const WebexSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-67.5"
				y="-358.5"
				width="2060"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<mask
				id="mask0_719_13847"
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="4"
				y="8"
				width="24"
				height="17"
			>
				<path d="M27.3332 8.23584H4.6665V24.7345H27.3332V8.23584Z" fill="white" />
			</mask>
			<g mask="url(#mask0_719_13847)">
				<path
					d="M11.6995 24.6691C7.50242 24.6691 6.07389 19.3611 5.75381 18.3285C4.94999 15.7356 4.70563 13.3998 4.67976 13.1547C4.5305 11.7404 5.66487 10.7561 6.90986 10.7561C7.85251 10.7561 8.94657 11.3204 9.09153 12.6895C9.11665 12.9198 9.30832 14.9059 9.98629 17.0699C10.6938 19.3284 11.4444 20.197 11.9849 20.197C12.8578 20.197 13.3903 17.955 13.8612 15.8203C14.2081 14.2475 14.583 12.6627 15.3233 11.2549C16.6112 8.80577 18.5573 8.23584 20.2386 8.23584C23.9252 8.23584 25.7703 12.5072 25.7703 13.6138C25.7703 15.4632 24.2619 15.9349 23.6081 15.9349C22.1783 15.9349 21.6936 14.9768 21.2855 14.137C20.9186 13.3815 20.5353 12.7534 20.0398 12.7534C19.877 12.7534 19.726 12.8358 19.5865 12.9777C18.3548 14.2295 17.9419 20.7785 15.4792 23.2815C14.114 24.6691 12.6285 24.6691 11.6995 24.6691Z"
					fill="#00BBFF"
				/>
				<path
					d="M25.0906 10.7561C24.9244 10.7561 24.7573 10.7718 24.5934 10.8041C25.3726 11.9278 25.7626 13.1051 25.7626 13.6137C25.7626 15.4631 24.2542 15.9348 23.6004 15.9348C23.0902 15.9348 22.7004 15.8128 22.3915 15.6177C22.3886 15.6293 22.3858 15.6408 22.3829 15.6524C22.291 16.0194 22.2185 16.4211 22.093 16.8121C21.8516 17.5637 21.526 18.4223 21.1784 19.0866C20.8036 19.8029 20.4326 20.222 19.9904 20.2C19.4874 20.175 19.0797 19.5267 18.5729 17.6946C18.4095 17.1039 18.2581 16.4562 18.1179 15.8203C17.77 14.2428 17.343 12.6566 16.6129 11.2549C15.4203 8.96551 13.386 8.23584 11.7619 8.23584C10.2557 8.23584 9.13044 8.94893 8.24644 9.84744C8.00217 10.0957 7.73528 10.4303 7.46729 10.8234C8.23832 11.0091 8.96737 11.5895 9.08374 12.6894C9.10671 12.8991 9.26763 14.5647 9.80821 16.495C9.9633 16.0111 10.1895 15.2944 10.7148 14.137C10.9724 13.607 11.2048 13.2575 11.4144 13.0445C11.6067 12.849 11.7798 12.7683 11.9358 12.7683C12.1039 12.7683 12.678 12.9222 13.2369 14.8835C13.9301 17.3157 14.4459 21.1863 16.4113 23.2414C17.2781 24.1479 18.4912 24.7345 20.1724 24.7345C21.6476 24.7345 22.8775 24.0847 23.7544 23.181C25.1962 21.6948 25.9862 19.2377 26.268 18.3285C27.0699 15.7417 27.2946 13.4023 27.3207 13.1547C27.4699 11.7404 26.2784 10.7561 25.0906 10.7561Z"
					fill="#316AFF"
				/>
			</g>
		</svg>
	);
};
